import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import VehiculeService from '../services/VehiculeService';
import { baseUrls, itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import InstitutionService from '../services/InstitutionService';
import { InputNumber } from 'primereact/inputnumber';
import TypeMaterielService from '../services/TypeMaterielService';
import FinancementService from '../services/FinancementService';
import { Image } from 'primereact/image';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';


const Vehicule = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        VehiculeService.get((data, status) => {
                setLoading(false); 
                console.log(data);
                if(status) setItems(data); 
            }
        );
    }

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        console.log(item);
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                VehiculeService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }

    return (
        <>
            <h5>Liste des véhicules</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}*/
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" sortable  hidden />
                <Column field="immatriculation" header="Immatriculation" sortable />
                <Column header="Photo"
                    body={(item) => <Image src={item.image ? `${baseUrls}/api/filestore/download/${item.image}` : 'assets/demo/images/pas_dispo.jpeg'} 
                        alt='Mon image' className="shadow-2" width={100} preview
                        />}
                    />
                <Column field="marque" header="Marque" sortable />
                <Column field="modele" header="Modèle" sortable />
                <Column field="nbrePlace" header="Nombre de places" sortable />
                <Column field="etatVehicule" header="Etat" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.etatVehicule === 'EN_BON_ETAT' ? 'qualified' : 'unqualified'}`}>
                        {item.etatVehicule /*=== 'EN_BON_ETAT' ? 'EN BON ÉTAT' : 'EN_PANNE'*/}
                    </span>
                } />
                <Column field="institution.libelle" header="Institution" sortable />

                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
                {/*
                    <div style={{display: 'flex flex-', flexDirection: 'row-reverse'}}>    
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={()=> deleteItem(selectedItem)}/>
                        <span style={{padding: '.3rem'}}/>
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success" onClick={() => editItem(selectedItem)}/>
                        <span style={{padding: '.3rem'}}/>
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success" onClick={() => editItem(selectedItem)}/>
                        <span style={{padding: '.3rem'}}/> 
                        <Button 
                            icon={`pi pi-${selectedItem.inactif ? 'lock-open' : 'lock'}`} 
                            className={`p-button-rounded p-button-${selectedItem.inactif ? 'danger' : 'normal'}`} 
                            tooltip={selectedItem.inactif ? 'Déverouiller' : 'Verrouiller'}
                            onClick={()=> deleteItem(selectedItem)}/> 
                    </div>
                */} 
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);
    const[loading2, setLoading2] = useState(false);

    const [institutions, setInstitutions] = useState([]);
    const [typeMateriels, setTypeMateriels ] = useState([]);
    const [financements, setFinancements] = useState([]);
    const [file, setFile] = useState(null);

    useEffect(()=> {
        if(!visible) return;
        InstitutionService.get((data)=> data && setInstitutions(data), {size: pageMaxSize});
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        TypeMaterielService.get((data)=> data && setTypeMateriels(data), {size: pageMaxSize});
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        FinancementService.get((data)=> data && setFinancements(data), {size: pageMaxSize});
    }, [visible])
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, image, [e.target.id]: value});
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }

    const [image, setImage] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const showError = () => {
        toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Veuillez renseigner ces champs', life: 30000 });
    };

    const submit = () => {
        //console.log(data);
        setSubmitted(true);

        //console.log(submitted);
        if(submitted === false /* || !data.typeMateriel || data.immatriculation === null || data.numeroChassis === null || data.marque === null || data.modele === null || data.nbrePlace === null || !data.etatVehicule || data.dateAcquisition || !data.financement || !data.institution  */ ){
            //showError()
        } else {
            setYesNo(
                {   
                    visible: true,
                    message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                    hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                    callback : ()=> {
                        setLoading(true);
                        let onResponse = (data, status)=> {
                                setLoading(false);
                                if(!status) return;
                                hide();
                                callback();
                        }
                        if(image) data.image = image;
                        if(data.id) VehiculeService.update(data, onResponse);  
                        else {
                            VehiculeService.add(data, onResponse); 
                            console.log(data); 
                            //VehiculeService.addFile(formData)
                        } 
                    },
                    
                }
            )
        }
    }

    const toast = useRef();
    const showSuccess = () => {
        toast.current.show({severity:'success', summary: 'Successfully', detail:'Image uploadé avec succès !', life: 3000});
    }

    const upload = ()=>{
        let formData = new FormData();
        formData.append('file', file);
        setLoading2(true);
        axios.post(`${baseUrls}/api/filestore/upload/doc`, formData)
            .then(response => response)
            .then(data => {
                setImage(data?.data?.uuid);
                console.log(data.data.uuid);
                showSuccess();
                setLoading2(false);
            })
            .catch(error => {
                console.error(error);
                setLoading2(false);
            });
    }

    const choice = [
        { label: "OUI", value: true },
        { label: "NON", value: false }
    ]

    const choiceEtatVehicule = [
        {label: 'EN BON ÉTAT', value: 'EN_BON_ETAT'},
        {label: 'EN PANNE', value: 'EN_PANNE'}
    ]

    //const previousDate = new Date(data.dateReception);
    
    return(
        <Dialog visible={visible} style={{ width: '1000px' }} header="Détails du véhicule" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
        >
            <Toast ref={toast} />
            <div className="card">
                <div className="field ">
                    <label htmlFor="file">Photo</label>
                    <InputText id="file" type="file" value={data && data?.file}
                        onChange={(e) => setFile(e.target.files[0])} placeholder="" />
                </div>
                <Button label="Uploader" /*icon="pi pi-image"*/ className="p-button-success mr-2"
                    onClick={upload} loading={loading2} />
            </div>

            

            <div className="card">
                    <div className="grid p-fluid mt-3">
                        
                        <div className="field" hidden>
                            <label htmlFor="id">Identifiant</label>
                            <InputText id="id" value={data && data?.id} onChange={bind} 
                                placeholder="" /> 
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="typeMateriel">Type matériel *</label>
                            <Dropdown id="typeMateriel" options={typeMateriels}
                                 value={data?.typeMateriel} onChange={bind} 
                                optionLabel="libelleTypeMateriel" /*optionLabel={(data)=> data.nom + " " + data.prenom}*/
                                /*optionValue="id"*/ required className={classNames({  'p-invalid': submitted && !data?.typeMateriel })} 
                                placeholder="Aucune sélection"
                                //filter endsWith
                            />
                            {/* {submitted && !data?.typeMateriel && <small className="p-invalid">
                                Le choix du type matériel est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="immatriculation">Immatriculation</label>
                            <InputText id="immatriculation" value={data && data?.immatriculation} 
                                onChange={bind}  placeholder="ex: BA 1452" 
                                required className={classNames({ 'p-invalid': submitted && !data?.immatriculation })}
                            />
                            {/* {submitted && !data?.immatriculation && <small className="p-invalid">
                                L'immatriculation est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="numeroChassis">Numéro chassis</label>
                            <InputText id="numeroChassis" value={data && data?.numeroChassis} 
                                onChange={bind}  placeholder="" 
                                required className={classNames({ 'p-invalid': submitted && !data?.numeroChassis })}
                            />
                            {/* {submitted && !data?.numeroChassis && <small className="p-invalid">
                                Le numéro chassis est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="marque">Marque</label>
                            <InputText id="marque" value={data && data?.marque} onChange={bind} 
                                placeholder="" 
                                required className={classNames({ 'p-invalid': submitted && !data?.marque })}
                            />
                            {/* {submitted && !data?.marque && <small className="p-invalid">
                                La marque est requise!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4" >
                            <label htmlFor="modele">Modèle</label>
                            <InputText id="modele" value={data?.modele} onChange={bind} 
                                required className={classNames({ 'p-invalid': submitted && !data?.modele })}
                            />
                            {/* {submitted && !data?.modele && <small className="p-invalid">
                                Le modèle est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="nbrePlace">Nombre de place</label>
                            <InputText id="nbrePlace" value={data && data?.nbrePlace} 
                                onChange={bind}  placeholder="" keyfilter="num" 
                                required className={classNames({ 'p-invalid': submitted && !data?.nbrePlace })}
                            />
                            {/* {submitted && !data?.nbrePlace && <small className="p-invalid">
                                Le nombre de place est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="etatVehicule">Etat véhicule</label>
                            <Dropdown id="etatVehicule" onChange={bind} placeholder="Aucune sélection"
                                options={choiceEtatVehicule} optionLabel="label"
                                value={data?.etatVehicule} required className={classNames({ 'p-invalid': submitted && !data?.etatVehicule })}
                            />
                            {/* {submitted && !data?.etatVehicule && <small className="p-invalid">
                                Le choix de l'état du véhicule est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateAcquisition">Date acquisition</label>
                            <Calendar id="dateAcquisition" value={data && new Date(data?.dateAcquisition)} 
                                onChange={bind}  mask='99/99/9999' showIcon
                                required className={classNames({ 'p-invalid': submitted && !data?.dateAcquisition })}
                            />
                            {/* {submitted && !data?.dateAcquisition && <small className="p-invalid">
                                La date d'acquisition est requise!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="valeurAcquisition">Valeur acquisition</label>
                            <InputText id="valeurAcquisition" value={data && data?.valeurAcquisition} 
                                onChange={bind}  placeholder="" keyfilter="num"/>
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="kilometrage">Kilométrage</label>
                            <InputNumber id="kilometrage" value={data && data?.kilometrage} 
                                onValueChange={bind}  placeholder="" keyfilter="num"/>
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="institution">Institution</label>
                            <Dropdown id="institution" options={institutions} value={data?.institution} onChange={bind}
                                optionLabel="libelle" /*optionLabel={(data)=> data.nom + " " + data.prenom}*/
                                placeholder="Aucune sélection"
                                required className={classNames({ 'p-invalid': submitted && !data?.institution })}
                            />
                            {/* {submitted && !data?.institution && <small className="p-invalid">
                                Le choix de l'institution est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="financement">Financement</label>
                            <Dropdown id="financement" options={financements} 
                                value={data?.financement} onChange={bind}
                                optionLabel="libelleFinancement" /*optionLabel={(data)=> data.nom + " " + data.prenom}*/
                                /*optionValue="id"*/
                                placeholder="Aucune sélection"
                                required className={classNames({ 'p-invalid': submitted && !data?.financement })}
                            />
                            {/* {submitted && !data?.financement && <small className="p-invalid">
                                Le choix du financement est requis!
                            </small>} */}
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateReception">Date réception</label>
                            <Calendar id="dateReception" value={data && new Date(data?.dateReception)} 
                                onChange={bind}   mask='99/99/9999' showIcon />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateMiseMarche">Date mise en circulation</label>
                            <Calendar id="dateMiseMarche" value={data && new Date(data?.dateMiseMarche)} 
                                onChange={bind}  mask='99/99/9999' showIcon/>
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="miseEnRebut">Mise en rebut</label>
                            <Dropdown id="miseEnRebut" options={choice} value={data && data?.miseEnRebut} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateDebutVisiteTechnique">Date début visite technique</label>
                            <Calendar id="dateDebutVisiteTechnique" value={data && new Date(data?.dateDebutVisiteTechnique)} 
                                onChange={bind}   mask='99/99/9999' showIcon />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateFinVisiteTechnique">Date fin visite technique</label>
                            <Calendar id="dateFinVisiteTechnique" value={data && new Date(data?.dateFinVisiteTechnique)}
                                 onChange={bind}   mask='99/99/9999' showIcon/>
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="dateEntretien">Date entretien</label>
                            <Calendar id="dateEntretien" value={data && new Date(data?.dateEntretien)} onChange={bind} 
                                 mask='99/99/9999' showIcon/>
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="alimentation">Alimentation</label>
                            <InputText id="alimentation" value={data && data?.alimentation} 
                                onChange={bind}  placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="allumage">Allumage</label>
                            <InputText id="allumage" value={data && data?.allumage} onChange={bind} 
                                 placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="assistanceFreinage">Assistance freinage</label>
                            <Dropdown id="assistanceFreinage" options={choice}
                                value={data && data?.assistanceFreinage} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>

                        <div className="field col-12 md:col-4" >
                            <label htmlFor="capaciteCarburant">Capacité carburant</label>
                            <InputText id="capaciteCarburant" value={data?.capaciteCarburant} onChange={bind} />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="categorie">Catégorie</label>
                            <InputText id="categorie" value={data && data?.categorie} onChange={bind}   
                                placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="cession">Cession</label>
                            <Dropdown id="cession" options={choice}
                                value={data && data?.cession} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="chargeUtile">Charge utile</label>
                            <InputText id="chargeUtile" value={data && data?.chargeUtile} 
                                onChange={bind}  placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="clim">Climatiseur</label>
                            <Dropdown id="clim" options={choice}
                                value={data && data?.clim} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="nbreCynlindre">Nombre cynlindre</label>
                            <InputText id="nbreCynlindre" value={data && data?.nbreCynlindre} 
                                onChange={bind}  placeholder="" keyfilter="num"/>
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="numeroMoteur">Numéro moteur</label>
                            <InputText id="numeroMoteur" value={data && data?.numeroMoteur} 
                                onChange={bind}  placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="pma">PMA</label>
                            <InputText id="pma" value={data && data?.pma} onChange={bind} 
                                 placeholder="" />
                        </div>

                        <div className="field col-12 md:col-4">
                            <label htmlFor="puissance">Puissance</label>
                            <InputText id="puissance" value={data && data?.puissance} onChange={bind} 
                                 placeholder="" />
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="vitesse">Vitesse</label>
                            <InputNumber id="vitesse" value={data && data?.vitesse} onValueChange={bind} 
                                 placeholder="" />
                        </div>
                        
                        <div className="field col-12 md:col-4" >
                            <label htmlFor="cynlindree">Cynlindrée</label>
                            <InputText id="cynlindree" value={data?.cynlindree} onChange={bind} />
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="directionAssistee">Direction assistée</label>
                            <Dropdown id="directionAssistee" options={choice}
                                value={data && data?.directionAssistee} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="dureeGuarantie">Durée guarantie</label>
                            <InputText id="dureeGuarantie" value={data && data?.dureeGuarantie} 
                                onChange={bind}  placeholder="" keyfilter="num" />
                        </div>
                        <div className="field col-12 md:col-4" >
                            <label htmlFor="dureeVie">Durée vie</label>
                            <InputText id="dureeVie" value={data?.dureeVie} onChange={bind} keyfilter="num"/>
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="energie">Energie</label>
                            <InputText id="energie" value={data && data?.energie} onChange={bind}   
                                placeholder="" />
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="freins">Freins</label>
                            <InputText id="freins" value={data && data?.freins} onChange={bind} 
                                 placeholder="" />
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="pva">PVA</label>
                            <InputText id="pva" value={data && data?.pva} onChange={bind} 
                                 placeholder="" />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="radio">Radio</label>
                            <Dropdown id="radio" options={choice} value={data && data?.radio} onChange={bind} 
                                placeholder="Aucune sélection" />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="typeEnergie">Type énergie</label>
                            <InputText id="typeEnergie" value={data && data?.typeEnergie} 
                                onChange={bind}  placeholder="" />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="typeTransmission">Type transmission</label>
                            <InputText id="typeTransmission" value={data && data?.typeTransmission} 
                            onChange={bind}  placeholder="" />
                        </div>
                        
                        
                    </div>
                   
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default Vehicule;